module.exports = __webpack_public_path__ + "img/jack-larson.24119fec.png";